export default {
	props: {
		autoSignOut:{
			type:Boolean,
			default:true,
		},
		clientId: String,
	},
	data(){
		return {}
	},
	methods: {
		init(){
			let self = this;
			gapi.load('auth2', function(){
				// Retrieve the singleton for the GoogleAuth library and set up the client.
				let auth2 = gapi.auth2.init({
					client_id: self.clientId,
					cookiepolicy: 'single_host_origin',
					scope: 'profile email'
				});
				auth2.attachClickHandler(self.$refs.googleSignInButton, {}, self.onSuccess, self.onFailure);
			});
		},
		onSuccess (googleUser) {
			let profile = googleUser.getBasicProfile();
			this.$emit('success', {
				'id' : profile.getId(),
				'name': profile.getName(),
				'email': profile.getEmail(),
				'first_name': profile.getGivenName(),
				'last_name': profile.getFamilyName(),
			});
			if(this.autoSignOut){
				this.onSignOut();
			}
		},
		onFailure(error){
			//this.$emit('failure', error);
		},
		onSignOut() {
			var auth2 = gapi.auth2.getAuthInstance();
			auth2.signOut().then(function () {
				//console.log('User signed out.');
			});
		}
	},
	mounted(){
		let self = this;
		ITTI.defer(function (){
			self.init();
		}, ['googleAPIClientJS']);
	},
	template: `
<a ref="googleSignInButton" class="sign-in-btn-google"></a>

`,
}
